export default {
      id: "clock-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#clock",
      toString: function () {
        return this.url;
      }
    }